import React, { useEffect, useState } from "react";
import { ProductServices } from "../../../core/services/ProductServices";
import { Button, SelectPicker } from "rsuite";
import ProductStepTwo from "./ProductStepTwo";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import { Link, useParams, useSearchParams } from "react-router-dom";
import "./Product.css";
import { useTranslation } from "react-i18next";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { messageTypeArr } from "../../../core/config/AppConstants";
import { ContentRoutes } from "../../../navigation/NavConstant";

const ProductStepOne = () => {
  const { t } = useTranslation();
  const [productTypes, setProductTypes] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState("");
  const [formStep, setFormStep] = useState(1);
  const [stepTwoFields, setStepTwoFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  let [decryptedParams] = useDecryptedParams(params);

  useEffect(() => {
    if (!decryptedParams?.id || !decryptedParams) {
      getProductTypes();
    }
  }, []);

  useEffect(() => {
    if (decryptedParams?.id) {
      let prod_type: any = searchParams.get("prod_type");
      setSelectedProductType(prod_type);
      getStepTwoFields(+prod_type);
    }
  }, [decryptedParams]);

  const getProductTypes = async () => {
    try {
      setLoading(true);
      const res: any = await ProductServices.getProductTypes();
      setProductTypes(res?.data?.data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  };

  const getStepTwoFields = async (productType: number) => {
    try {
      if (productType) {
        setLoading(true);
        const res: any = await ProductServices.getProductTypeFields(
          productType
        );
        if (res?.data && res?.data?.data) {
          setStepTwoFields(res?.data?.data);
          setFormStep(2);
        }
        setLoading(false);
      } else {
        UtilityServices.showToaster({
          message: t("REQUIRED_SELECT", {
            field: t("PRODUCT").toLowerCase() + " " + t("TYPE").toLowerCase(),
          }),
          type: messageTypeArr.error,
        });
      }
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  };

  const handleNext = () => {
    getStepTwoFields(+selectedProductType);
  };

  return (
    <div>
    <style>
        {`
          .rs-container-has-sidebar {
            height: 100vh
          }
        `}
      </style>
    <div style={{ padding: "10px 30px" }}>
      <h4 className="mb-2">
        {decryptedParams?.id ? "Update " : "Create "} Product
      </h4>
      <div className="d-flex">
        {formStep === 1 && !decryptedParams?.id ? (
          <div style={{ width: "25%", margin: "0 20px 0 0" }}>
            <label className="mb-1"> Select Product Type : </label>
            <SelectPicker
              onClean={() => {
                setSelectedProductType("");
                setStepTwoFields([]);
                setFormStep(1);
              }}
              onSelect={(e: any) => {
                setSelectedProductType(e);
              }}
              searchable={false}
              valueKey="id"
              labelKey="product_type_name"
              data={productTypes}
              value={selectedProductType}
            />
          </div>
        ) : null}

        <div className="form-step-2">
          {stepTwoFields && selectedProductType !== "" ? (
            <ProductStepTwo
              fieldsInfo={stepTwoFields}
              productType={selectedProductType}
              setStep={setFormStep}
              step={formStep}
            />
          ) : null}
        </div>

        {formStep === 1 && !decryptedParams?.id ? (
          <div className="text-center mt-3 space">
            <Button
              appearance="primary"
              color="green"
              onClick={() => {
                handleNext();
              }}
              loading={loading}
            >
              {t("NEXT")}
            </Button>{" "}
            <Link to={ContentRoutes.PRODUCTS}>
              <Button appearance="primary" color="blue" type="button">
                {t("BACK")} {t("TO").toLocaleLowerCase()}{" "}
                {t("LIST").toLocaleLowerCase()}
              </Button>
            </Link>
          </div>
        ) : null}
      </div>
    </div>
    </div>
  );
};

export default ProductStepOne;
